var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var BellLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9a7 7 0 1 1 14 0v5.768l.223.148 2.13 1.42A1.454 1.454 0 0 1 20.546 19H3.454a1.454 1.454 0 0 1-.806-2.664l2.13-1.42.222-.148V9Zm3.536 11H3.454a2.454 2.454 0 0 1-1.361-4.496L4 14.232V9a8 8 0 1 1 16 0v5.232l1.907 1.272A2.454 2.454 0 0 1 20.546 20h-5.082a3.5 3.5 0 0 1-6.928 0Zm1.015 0a2.5 2.5 0 0 0 4.899 0h-4.9Z",
    fill: "currentColor"
  }));
});
BellLg.displayName = "BellLg";
export default BellLg;